var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-scrollbar__wrap wrap-white padding-20" },
    [
      _c(
        "div",
        { staticClass: "el-scrollbar__view" },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "登录", name: "first" } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("h3", [_vm._v("单一登陆配置")])]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "loginFormSetting",
                          attrs: { size: "small", model: _vm.loginFormSetting },
                        },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    "true-label": "0",
                                    "false-label": "1",
                                  },
                                  model: {
                                    value:
                                      _vm.loginFormSetting.multiAccountLogin,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.loginFormSetting,
                                        "multiAccountLogin",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "loginFormSetting.multiAccountLogin",
                                  },
                                },
                                [_vm._v("单一登录")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.loginFormSetting.singleLoginType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.loginFormSetting,
                                        "singleLoginType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "loginFormSetting.singleLoginType",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.loginFormSetting
                                            .multiAccountLogin === "1",
                                        label: "1",
                                      },
                                    },
                                    [_vm._v("后登陆踢出先登录")]
                                  ),
                                  _c(
                                    "el-radio",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.loginFormSetting
                                            .multiAccountLogin === "1",
                                        label: "2",
                                      },
                                    },
                                    [_vm._v("已登陆禁止再登陆")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.doSubmit(_vm.loginFormSetting)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "外观", name: "second" } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("h3", [_vm._v("外观配置")])]
                      ),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            size: "small",
                            "label-width": "150px",
                            model: _vm.themeFormSetting,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品标题" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.themeFormSetting.productName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.themeFormSetting,
                                      "productName",
                                      $$v
                                    )
                                  },
                                  expression: "themeFormSetting.productName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "产品logo" } },
                            [
                              _c("image-select", {
                                model: {
                                  value: _vm.themeFormSetting.logo,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.themeFormSetting, "logo", $$v)
                                  },
                                  expression: "themeFormSetting.logo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "默认布局" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.themeFormSetting.defaultLayout,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.themeFormSetting,
                                        "defaultLayout",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "themeFormSetting.defaultLayout",
                                  },
                                },
                                _vm._l(_vm.layouts, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-form-item", { attrs: { label: "默认主题" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "tag-group",
                                staticStyle: { "margin-top": "7px" },
                              },
                              _vm._l(_vm.colorList, function (item, index) {
                                return _c(
                                  "el-tooltip",
                                  {
                                    key: index,
                                    attrs: {
                                      effect: "dark",
                                      content: item.key,
                                      placement: "top-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "themeColorTag",
                                        attrs: { color: item.color },
                                        on: {
                                          click: function ($event) {
                                            _vm.themeFormSetting.defaultTheme =
                                              item.color
                                          },
                                        },
                                      },
                                      [
                                        item.color ===
                                        _vm.themeFormSetting.defaultTheme
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-check themeColorFont",
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ]),
                          _c(
                            "el-form-item",
                            { attrs: { label: "首页地址" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.themeFormSetting.homeUrl,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.themeFormSetting,
                                      "homeUrl",
                                      $$v
                                    )
                                  },
                                  expression: "themeFormSetting.homeUrl",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.doSubmit(_vm.themeFormSetting)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "短信", name: "third" } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("h3", [
                            _vm._v("阿里大鱼短信配置("),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "https://dayu.aliyun.com",
                                  target: "_blank",
                                },
                              },
                              [_vm._v("官网")]
                            ),
                            _vm._v(")"),
                          ]),
                        ]
                      ),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            size: "small",
                            "label-width": "150px",
                            model: _vm.smsFormSetting,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "accessKeyId",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "此处需要替换成开发者自己的AK(在阿里云访问控制台寻找)",
                                },
                                model: {
                                  value: _vm.smsFormSetting.accessKeyId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.smsFormSetting,
                                      "accessKeyId",
                                      $$v
                                    )
                                  },
                                  expression: "smsFormSetting.accessKeyId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "accessKeySecret",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "此处需要替换成开发者自己的AK(在阿里云访问控制台寻找)",
                                },
                                model: {
                                  value: _vm.smsFormSetting.accessKeySecret,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.smsFormSetting,
                                      "accessKeySecret",
                                      $$v
                                    )
                                  },
                                  expression: "smsFormSetting.accessKeySecret",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "短信签名",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "必填:短信签名-可在短信控制台中找到",
                                },
                                model: {
                                  value: _vm.smsFormSetting.signature,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.smsFormSetting,
                                      "signature",
                                      $$v
                                    )
                                  },
                                  expression: "smsFormSetting.signature",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "短信模板",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder:
                                    "必填:短信模板编号-可在短信控制台中找到",
                                },
                                model: {
                                  value: _vm.smsFormSetting.templateCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.smsFormSetting,
                                      "templateCode",
                                      $$v
                                    )
                                  },
                                  expression: "smsFormSetting.templateCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.doSubmit(_vm.smsFormSetting)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "邮箱", name: "fourth" } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("h3", [_vm._v("发件人账户")])]
                      ),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            size: "small",
                            "label-width": "150px",
                            model: _vm.emailFormSetting,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "邮箱服务器地址",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  placeholder:
                                    " 邮件服务器的SMTP地址，默认为smtp.<发件人邮箱后缀>",
                                },
                                model: {
                                  value: _vm.emailFormSetting.smtp,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.emailFormSetting, "smtp", $$v)
                                  },
                                  expression: "emailFormSetting.smtp",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "邮箱服务器端口",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  placeholder: "邮件服务器的SMTP端口，默认25",
                                },
                                model: {
                                  value: _vm.emailFormSetting.port,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.emailFormSetting, "port", $$v)
                                  },
                                  expression: "emailFormSetting.port",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "系统邮箱地址",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  placeholder: "用户名，默认为发件人邮箱前缀",
                                },
                                model: {
                                  value: _vm.emailFormSetting.mailName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.emailFormSetting,
                                      "mailName",
                                      $$v
                                    )
                                  },
                                  expression: "emailFormSetting.mailName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "系统邮箱密码",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                attrs: {
                                  placeholder:
                                    "密码（注意，某些邮箱需要为SMTP服务单独设置密码，详情查看相关帮助）",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.emailFormSetting.mailPassword,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.emailFormSetting,
                                      "mailPassword",
                                      $$v
                                    )
                                  },
                                  expression: "emailFormSetting.mailPassword",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.doSubmit(_vm.emailFormSetting)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("h3", [_vm._v("客户填写设计咨询绑定发送邮箱")])]
                      ),
                      _c(
                        "el-form",
                        {
                          attrs: {
                            size: "small",
                            "label-width": "150px",
                            model: _vm.emailFormSetting,
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "绑定邮箱地址",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "250px" },
                                attrs: { placeholder: "请输入绑定邮箱地址" },
                                model: {
                                  value: _vm.emailFormSetting.sendEmail,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.emailFormSetting,
                                      "sendEmail",
                                      $$v
                                    )
                                  },
                                  expression: "emailFormSetting.sendEmail",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "抄送邮箱地址" } },
                            [
                              _c(
                                "div",
                                { staticClass: "cc-email-box" },
                                [
                                  _vm._l(
                                    _vm.ccEmailList,
                                    function (email, index) {
                                      return _c(
                                        "el-tag",
                                        {
                                          key: index,
                                          staticClass: "cc-email-tag",
                                          attrs: { closable: "", type: "info" },
                                          on: {
                                            close: function ($event) {
                                              return _vm.removeCcEmail(index)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(email))]
                                      )
                                    }
                                  ),
                                  _vm.ccInputVisible
                                    ? _c("el-input", {
                                        ref: "ccInput",
                                        staticStyle: { width: "220px" },
                                        attrs: {
                                          size: "small",
                                          placeholder:
                                            "请输入抄送邮箱，回车确认",
                                        },
                                        on: { blur: _vm.addCcEmail },
                                        nativeOn: {
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.addCcEmail.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.ccInputValue,
                                          callback: function ($$v) {
                                            _vm.ccInputValue = $$v
                                          },
                                          expression: "ccInputValue",
                                        },
                                      })
                                    : _c("el-button", {
                                        staticClass: "cc-add-btn",
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                          icon: "el-icon-plus",
                                          circle: "",
                                        },
                                        on: { click: _vm.showCcInput },
                                      }),
                                ],
                                2
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.handleSaveEmail },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "上传", name: "upload" } },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_c("h3", [_vm._v("上传文件配置")])]
                      ),
                      _c(
                        "el-form",
                        {
                          ref: "uploadSetting",
                          attrs: { size: "small", model: _vm.uploadSetting },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "限制上传视频大小",
                                prop: "uploadVideoSize",
                                rules: [
                                  {
                                    required: true,
                                    message: "必填项不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  staticStyle: { width: "250px" },
                                  attrs: { placeholder: "请输入" },
                                  on: { input: _vm.handleInput },
                                  model: {
                                    value: _vm.uploadSetting.uploadVideoSize,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.uploadSetting,
                                        "uploadVideoSize",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "uploadSetting.uploadVideoSize",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("MB"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.doSubmit(_vm.uploadSetting)
                                    },
                                  },
                                },
                                [_vm._v("保存")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }